import { loadStripe } from '@stripe/stripe-js';
import { supabase } from '../supabase/client';

// Initialize Stripe
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

/**
 * Creates a checkout session using the simplified stripe-checkout2 endpoint
 * This endpoint doesn't require authentication and just collects email during checkout
 */
export async function createUnauthenticatedCheckoutSession(options?: { priceId?: string; locale?: string; promo_code?: string }) {
  try {
    const { data, error } = await supabase.functions.invoke('stripe-checkout2', {
      body: { priceId: options?.priceId, locale: options?.locale, promo_code: options?.promo_code }
    });

    if (error) {
      console.error('Supabase Function Error:', error);
      throw new Error(error.message);
    }

    // If the URL is directly provided, redirect to it
    if (data.url) {
      window.location.href = data.url;
      return;
    }
    
    // Otherwise use the Stripe SDK to redirect
    const stripe = await stripePromise;
    if (!stripe) throw new Error('Stripe failed to initialize');

    const { error: redirectError } = await stripe.redirectToCheckout({
      sessionId: data.sessionId
    });
    
    if (redirectError) {
      console.error('Stripe Redirect Error:', redirectError);
      throw redirectError;
    }
  } catch (error) {
    console.error('Checkout Error:', error);
    throw error;
  }
}

export async function redirectToBillingPortal(locale?: string) {
  try {
    const { data, error } = await supabase.functions.invoke('stripe-portal', {
      body: { locale }
    });

    if (error) throw error;
    window.location.href = data.url;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}
